import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MenuIcon, AnnotationIcon } from '@heroicons/react/solid';
import { useTranslation } from 'react-i18next';
import Rating from '../../../../components/Rating';

export function Panel() {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);

  return (
    <section className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col space-y-5 justify-center bg-white rounded-md p-5 shadow-md -mt-32">
        <div className="my-3 bg-gradient-to-br from-purple-500 via-sky-light to-sky-dark rounded-md shadow-md w-min text-white p-3">
          <AnnotationIcon className="w-8" />
        </div>
        <p>{t('courses.completed_this_course')}</p>
        <Rating onChange={setRating} rating={rating} disabled />
        <span className="flex-col space-y-5">
          <label>{t('courses.course_summary_provide_feedback')}</label>
          <textarea
            type="text"
            placeholder={'Feedback'}
            className="w-full rounded-md border-none outline-none bg-grey-super_light"
            rows={5}
            disabled
          />
        </span>
        <button
          type="button"
          className="bg-sky text-white rounded-md px-4 py-2 shadow-md hover:bg-sky-dark m-auto"
          disabled
        >
          {t('courses.finish_lesson')}
        </button>
      </div>
    </section>
  );
}

Panel.propTypes = {
  item: PropTypes.objectOf({
    image: PropTypes.string.isRequired,
  }).isRequired,
};

export function Preview(props) {
  const { selected } = props;
  const { t } = useTranslation();
  return (
    <div
      className={`h-full w-full text-sky mx-auto bg-grey-super_light rounded-md border-sky  ${
        selected ? 'opacity-100 border-3' : 'opacity-50 border-2'
      }`}
    >
      <MenuIcon className="h-10 w-10 text-sky mx-auto mt-8" />
      <p>{t('courses.closing')}</p>
    </div>
  );
}

Preview.propTypes = {
  selected: PropTypes.bool.isRequired,
};
